import { z } from 'zod'
import makeApiClient, { Type } from '@/features/api'
import { assertSchema } from '@/helpers/assert-schema'

const { sendGetRequest } = makeApiClient(Type.Core)

export type UserDetails = z.infer<typeof schema>

export const schema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  name: z.string(),
  emailAddress: z.string(),
  permissions: z.array(z.string()),
  organisationId: z.number().int().gt(0),
})

export default async function getUserDetails(id: string|'me'): Promise<UserDetails> {
  const { data } = await sendGetRequest(`users/${id}`)

  assertSchema(data, schema)

  return data
}